import { formatCreatedDate } from '../../utils/dates.ts';

const NEW_NOGOS_BASELINE = 'Counts consecutive no-gos from scans taken after this VA is saved.';
const UNKNOWN_SINCE = 'it was planned';

export interface SavedNogoBaseline {
    count: number;
    /** Instant the no-go window opened (last snooze or kind switch, else creation). */
    since: string | null;
}

// `since` is a timestamp, so it reads as the viewer's local day, not its UTC date prefix.
export function plannedNogosBaseline(saved: SavedNogoBaseline | null): string {
    if (saved === null) return NEW_NOGOS_BASELINE;
    const since = formatCreatedDate(saved.since ?? undefined) || UNKNOWN_SINCE;
    return `Counting since ${since} · ${saved.count} so far.`;
}
